/**
 * Force Hero Image to Show on Mobile
 * Removes gp-invisible class and forces lazy loaded images to display
 */

(function() {
  'use strict';
  
  // Function to force images to show
  function forceHeroImagesVisible() {
    // Only run on mobile devices
    if (window.innerWidth > 767) {
      return;
    }
    
    // Target the specific hero section
    const heroSection = document.querySelector('.gps-600673095509869420');
    if (!heroSection) {
      return;
    }
    
    // Remove gp-invisible class from all elements
    const invisibleElements = heroSection.querySelectorAll('.gp-invisible');
    invisibleElements.forEach(function(element) {
      element.classList.remove('gp-invisible');
      element.style.visibility = 'visible';
      element.style.opacity = '1';
      element.style.display = 'block';
    });
    
    // Force lazy loaded images to load immediately
    const lazyImages = heroSection.querySelectorAll('img[data-src], img.gp_lazyload');
    lazyImages.forEach(function(img) {
      // Set src from data-src if available
      if (img.dataset.src && !img.src.includes('http')) {
        img.src = img.dataset.src;
      }
      
      // Set srcset from data-srcset if available
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
      }
      
      // Remove lazy loading classes
      img.classList.remove('gp_lazyload', 'gp_lazyforbg', 'gp_lazybg_tl', 'gp_lazybg_mb');
      
      // Force visibility
      img.style.visibility = 'visible';
      img.style.opacity = '1';
      img.style.display = 'block';
      img.loading = 'eager';
    });
    
    // Force background images to load
    const bgElements = heroSection.querySelectorAll('.gp_lazybg, .hero-banner-bg');
    bgElements.forEach(function(element) {
      element.classList.remove('gp_lazybg');
      element.style.visibility = 'visible';
      element.style.opacity = '1';
      element.style.display = 'block';
      
      // If it has a data-bgi attribute or CSS variable, apply it
      const bgImage = element.style.getPropertyValue('--bgi');
      if (bgImage && bgImage.includes('data:image')) {
        // Replace placeholder with actual image
        const actualSrc = element.querySelector('img[data-src]');
        if (actualSrc && actualSrc.dataset.src) {
          element.style.setProperty('--bgi', 'url(' + actualSrc.dataset.src + ')');
        }
      }
    });
    
    // Force picture elements to show
    const pictures = heroSection.querySelectorAll('picture');
    pictures.forEach(function(picture) {
      picture.classList.remove('gp-invisible');
      picture.style.visibility = 'visible';
      picture.style.opacity = '1';
      picture.style.display = 'block';
      
      // Force sources to load
      const sources = picture.querySelectorAll('source[data-srcset]');
      sources.forEach(function(source) {
        if (source.dataset.srcset) {
          source.srcset = source.dataset.srcset;
        }
      });
    });
    
    console.log('Hero images forced visible on mobile');
  }
  
  // Run immediately when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceHeroImagesVisible);
  } else {
    forceHeroImagesVisible();
  }
  
  // Also run after a short delay to catch any late-loading elements
  setTimeout(forceHeroImagesVisible, 500);
  
  // Run on window resize if switching to mobile view
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (window.innerWidth <= 767) {
        forceHeroImagesVisible();
      }
    }, 250);
  });
})();
